import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/app/seame-web-b2b/apps/web-b2b/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/seame-web-b2b/apps/web-b2b/layouts/default.vue").then(m => m.default || m)),
  h5: defineAsyncComponent(() => import("/app/seame-web-b2b/apps/web-b2b/layouts/h5.vue").then(m => m.default || m))
}